import { createCrewLookupSelect } from './createCrewLookupSelect';

export const CertCategorySelect = createCrewLookupSelect('CertCategorySelect', 'certCategories');
export default CertCategorySelect;
